import { Directive, HostBinding, Input } from "@angular/core";

@Directive({
    selector: "[modTabIndex]",
})
export class TabIndexModifierDirective {
    @Input() @HostBinding("attr.tabindex") public modTabIndex = 0;
}
